export default __webpack_public_path__ + "static/media/WAS0430.34I-39844_-23879_0.de8fe314.jpg";